import React from "react";
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad'
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Button, Typography } from "@mui/material";

const BlogCard = () => {
  return (
    <Box
      width={{ xs: "300px", md: "420px" }}
      mx={1}
      mb={2}
      height="450px"
      boxShadow="0 0 30px rgb(209, 209, 209)"
    >
      <Box width="100%" height="70%" position="relative">
        <ImgLazyLoad>
          <img
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            src="https://playuganda.com/wp-content/uploads/2020/12/profile-pic.jpg"
            alt="blog"
          />
        </ImgLazyLoad>

        <Box
          position="absolute"
          width="60px"
          height="60px"
          bottom={0}
          left={0}
          textAlign="center"
          bgcolor="#FAC400"
          color="white"
          px={1}
          py={1}
        >
          <Typography variant="subtitle2">SEP</Typography>
          <Typography variant="subtitle1">12</Typography>
        </Box>
      </Box>
      <Box height="30%" py={2} px={2}>
        <Typography gutterBottom variant="h6" style={{ fontWeight: 700 }}>
          Blog Title
        </Typography>

        <Box textAlign="right">
          <Button
            variant="text"
            endIcon={<ArrowForwardIcon style={{ fontSize: "1.2rem" }} />}
          >
            Read More
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default BlogCard;
